import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { Observable, shareReplay } from 'rxjs';
import { PunchoutCustomerConfig } from '../../models/punchout';
import { ActionTypes } from '../../state/auth/actions';

@Injectable({ providedIn: 'root' })
export class PunchoutCurrentConfigService {
  protected http = inject(HttpClient);
  protected actions$ = inject(Actions, { optional: true });

  private cache$?: Observable<PunchoutCustomerConfig | null>;

  constructor() {
    this.actions$?.pipe(ofType(ActionTypes.Logout)).subscribe(() => (this.cache$ = undefined));
  }

  getCurrentConfig(): Observable<PunchoutCustomerConfig | null> {
    if (!this.cache$) {
      this.cache$ = this.http
        .get<PunchoutCustomerConfig | null>('json/punchout/current-config')
        .pipe(shareReplay({ bufferSize: 1, refCount: false }));
    }
    return this.cache$;
  }
}
